var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-card', {
    staticClass: "pr-12 pl-12 pt-7 pb-7",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('h3', {
    staticClass: "bold mr-n4"
  }, [_c('nobr', [_vm._v("Passwort vergessen")])], 1)]), _c('v-card-text', [_c('v-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.isFormValid,
      callback: function callback($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-Mail",
      "type": "mail",
      "rules": _vm.emailRules,
      "prepend-icon": "mdi-account-circle",
      "id": "mail"
    },
    model: {
      value: _vm.mail,
      callback: function callback($$v) {
        _vm.mail = $$v;
      },
      expression: "mail"
    }
  }), _vm.failure ? _c('h3', {
    staticClass: "mt-3 mb-3",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Etwas ging schief. Prüfen Sie Ihre Eingaben! ")]) : _vm._e(), _vm.success ? _c('h3', {
    staticClass: "mt-3 mb-3",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" Prüfen Sie Ihre E-Mails. Falls wir Ihre E-Mail Addresse kennen, senden wir Ihnen einen Code. Geben Sie diesen auf der nächsten Seite ein. " + _vm._s(_vm.countdown) + " ")]) : _vm._e(), _c('div', {
    staticClass: "mt-5 mb-7"
  }, [_c('v-btn', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.isResetButtonDisabled,
      "type": "submit",
      "text": "",
      "rounded": "",
      "outlined": ""
    }
  }, [_vm._v(" Zurücksetzen ")])], 1), _c('v-btn', {
    staticClass: "backButton",
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": _vm.submitted
    },
    on: {
      "click": function click($event) {
        return _vm.backToLogin($event);
      }
    }
  }, [_vm._v(" Zurück zum Login")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }